module.exports = __webpack_public_path__ + "static/zqb-lite.883eb65e.png";